import { Menu } from "antd";
import { Logo } from "../Logo";
import { GeneralStore } from "../../stores";
import { useNavigate, useLocation } from "react-router-dom";
import { SidebarItems } from "../../layouts/constants/SidebarData";

export const MainSidebarItems = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const sidebarItems = SidebarItems();
  const {
    sidebarCollapsed,
    mobileSidebarOpen,
    setContentPadding,
    setMobileSidebarOpen,
  } = GeneralStore();

  return (
    <div>
      <div
        className={`${
          !sidebarCollapsed && "px-0"
        } flex items-center sticky top-0 inset-x-0 bg-white z-40 px-1`}
      >
        <Logo className="h-24 w-[160px] " />
      </div>
      <Menu
        mode="inline"
        selectedKeys={[pathname]}
        onSelect={(e) => {
          navigate(e.key);
          if (mobileSidebarOpen) {
            setMobileSidebarOpen(false);
          }
          setContentPadding(true);
        }}
        items={sidebarItems.filter((item) => !item.disabled)}
        theme="light"
      />
    </div>
  );
};
